/**
 * Routine Finder — Quiz Questions
 * Exposes: window.rfQuestions  (array, 7 items)
 */
(function () {
  'use strict';

  const CONCERNS = [
    { value: 'fine_lines',        label: 'Fine lines & Wrinkles'             },
    { value: 'firmness',          label: 'Loss of Firmness & Elasticity'     },
    { value: 'congestion',        label: 'Congestion or Hormonal Breakouts'  },
    { value: 'hyperpigmentation', label: 'Hyperpigmentation or Dark Spots'   },
    { value: 'acne_marks',        label: 'Post-acne Marks (Red or Dark)'     },
    { value: 'sun_damage',        label: 'Sun Damage or Uneven Tone'         },
    { value: 'texture',           label: 'Rough or Uneven Texture'           },
    { value: 'sensitivity',       label: 'Sensitivity & Redness'              },
    { value: 'enlarged_pores',    label: 'Enlarged Pores'                    },
    { value: 'oily',              label: 'Excess Oil'                        },
    { value: 'dehydrated',        label: 'Dehydration'                       },
    { value: 'dull',              label: 'Dullness or Lack of Radiance'      },
  ];

  window.rfQuestions = [
    {
      id:    'age_bracket',
      title: 'Where do you sit in the below age brackets?',
      options: [
        { value: '18-24', label: '18–24' },
        { value: '25-34', label: '25–34' },
        { value: '35-44', label: '35–44' },
        { value: '45-54', label: '45–54' },
        { value: '55+',   label: '55+'   },
      ],
    },
    {
      id:       'gender',
      title:    'What is your gender?',
      required: false,
      options:  [
        { value: 'female',            label: 'Female'            },
        { value: 'male',              label: 'Male'              },
        { value: 'non_binary',        label: 'Non-binary'        },
        { value: 'prefer_not_to_say', label: 'Prefer not to say' },
      ],
    },
    {
      id:       'primary_concern',
      title:    'My skin needs the most support with:',
      subtitle: 'Select your top priority',
      options:  CONCERNS,
    },
    {
      id:        'secondary_concern',
      title:     'I also want to work on:',
      subtitle:  'Select your second priority',
      options:   CONCERNS,
      filterOut: 'primary_concern', // removes the primary choice from this list
    },
   {
      id:       'sensitised',
      title:    'Is your skin easily sensitised?',
      subtitle: 'Skin that is easily sensitised tends to react more quickly than usual. This might look like redness, stinging, itching, or a burning feeling after using certain products, being in the sun, or exposure to things like wind, heat, or pollution. You may also notice your skin feels tight, dry, or uncomfortable more often.',
      options:  [
        { value: 'yes', label: 'Yes' },
        { value: 'no',  label: 'No'  },
      ],
    },
    {
      id:    'pregnant',
      title: 'Are you pregnant or nursing?',
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no',  label: 'No'  },
      ],
    },
    {
      id:    'menopause',
      title: 'Are you going through perimenopause or menopause?',
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no',  label: 'No'  },
      ],
    },
  ];
})();
